import React, { useEffect, useRef } from "react";

const CustomInputChat = ({
    label, id, name, type = "text", value, onChange, onBlur, error, required, isTextArea, ...rest
}) => {
    const textareaRef = useRef(null);

    useEffect(() => {
        if (isTextArea && textareaRef.current) {
            if (!value) {
                // Reset to initial height when empty
                textareaRef.current.style.height = "28px";
                textareaRef.current.style.overflowY = "hidden";
            } else {
                if (textareaRef.current.scrollHeight < 100) {
                    textareaRef.current.style.overflowY = "hidden";
                    textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
                } else {
                    textareaRef.current.style.height = `96px`;
                    textareaRef.current.style.overflowY = `scroll`;
                }
            }
        }
    }, [value]);
    

    return (
        <div className={`custom-form-group ${isTextArea ? 'h-auto' : ''}`}>
            {label != null && String(label).trim() !== "" ? (
                <label htmlFor={id}>{label}</label>
            ) : null}
                <textarea
                    ref={textareaRef}
                    id={id}
                    name={name}
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    required={required}
                    style={{
                        overflowY: "hidden",
                        height: "28px",
                        resize: "none",
                        lineHeight: "1.5", // Maintain text alignment
                        boxSizing: "border-box",
                    }}
                    {...rest}
                />
            

            <hr className={error ? "error-hr-line" : ""} />
        </div>
    );
};

export default CustomInputChat;
